<template>
  <v-autocomplete
    v-show="providerSearchRequired"
    v-model="autoCompleteSearch"
    :items="searchResults"
    item-text="selectionDisplayName"
    :search-input.sync="comboBoxSearch"
    label="Medical Provider"
    persistent-hint
    small-chips
    box
    flat
    outline
    return-object
    cache-items
    hide-selected
    :disabled="uploadQ.length > 0"
  >
    <!-- Provider search list, if there is no results/data -->
    <template slot="no-data">
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title v-if="this.comboBoxSearch">No Matching Providers</v-list-tile-title>
          <v-list-tile-title v-else>Search by Name or Address</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>

    <template
      slot="selection"
      slot-scope="data"
    >
      <span v-if="data.item.selectionDisplayName">{{ data.item.selectionDisplayName }}<span style="opacity:0.3"> {{data.item.displayLocale}}</span></span>
      <span v-else>Error</span>
    </template>

    <!-- Provider search list -->
    <template
      slot="item"
      slot-scope="data"
    >
      <template>
        <v-list-tile-avatar>
          <v-icon>{{data.item.avatar}}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="data.item.selectionDisplayName"></v-list-tile-title>
          <v-list-tile-sub-title v-html="data.item.displayLocale"></v-list-tile-sub-title>
        </v-list-tile-content>
      </template>
    </template>

  </v-autocomplete>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      autoCompleteSearch: [],
      providerIDForSubmission: null,
      comboBoxSearch: null,
      comboBoxItems: [],
      uploadQ: [],
      providerSearchRequired: true
    }
  },
  methods: {
    ...mapActions('provider', ['getProviderIDFromNPI', 'search']),
    clearSearch() {
      this.autoCompleteSearch = []
      this.providerIDForSubmission = null
      this.comboBoxSearch = null
      this.comboBoxItems = []
      this.uploadQ = []
      this.providerSearchRequired = true
    }
  },
  computed: {
    ...mapState('provider', ['searchResults'])
  },
  watch: {
    autoCompleteSearch(val) {
      this.getProviderIDFromNPI({ npis: [val.npi] }).then(providerReturn => {
        this.providerIDForSubmission = providerReturn[0]._id
        this.$emit('selectedProvider', providerReturn[0])
      })
    },
    comboBoxSearch(val) {
      if (val) {
        this.search({ type: 'individual', terms: val })
      }
    }
  }
}
</script>


<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/providerSearchField.vue